import React, { useState, useContext } from "react";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";

import { useAlert } from "context/AlertContext";
import { Context } from "context/AuthContext";
import { Link, useNavigate } from "react-router-dom";

import { POST_USUARIO } from "services/Usuario";

import logo from "assets/imgs/Logo-Principal-Brancopng.png";
import ModalPDF from "components/ModalMarkdown";
import "./styles.scss";

const ContentRegistroUsuario = () => {
  const { showAlert } = useAlert();
  const { showLoader } = useContext(Context);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");

  const [usuario, setUsuario] = useState({
    nome: "",
    userName: "",
    dataNascimento: "",
    email: "",
    phoneNumber: "",
    senha: "",
    senhaConfirmacao: "",
    aceiteTermos: false,
    ativo: false,
  });
  const rota = process.env.REACT_APP_API_ROOT;
  const handleOpenModal = () => {
    setPdfUrl(rota + "/ArquivosTermoDeUso"); // Defina a URL do PDF
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    showLoader(true);

    var response = await POST_USUARIO(usuario);
    if (!response.errors) {
      showLoader(false);
      navigate("/registro-sucesso");
    } else {
      showAlert(response.errors, "danger");
      showLoader(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setUsuario({ ...usuario, [name]: checked });
    } else if (name === "phoneNumber") {
      setUsuario({ ...usuario, [name]: formatPhoneNumber(value) });
    } else {
      setUsuario({ ...usuario, [name]: value });
    }
  };

  const formatPhoneNumber = (value) => {
    // Remove caracteres não numéricos
    const numbers = value.replace(/[^\d]/g, "");

    // Formata o número
    if (numbers.length <= 2) {
      return `(${numbers}`;
    } else if (numbers.length <= 5) {
      return `(${numbers.slice(0, 2)}) ${numbers.slice(2)}`;
    } else if (numbers.length <= 10) {
      return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(
        7
      )}`;
    } else {
      return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(
        7,
        11
      )}`;
    }
  };

  const validate = () => {
    let errors = {};

    if (!usuario.nome) {
      errors.nome = "Nome de usuário é obrigatório.";
    }

    if (!usuario.dataNascimento) {
      errors.dataNascimento = "Data de nascimento é obrigatória.";
    }

    if (!usuario.email) {
      errors.email = "Email é obrigatório.";
    }

    if (!usuario.phoneNumber) {
      errors.phoneNumber = "Telefone é obrigatório.";
    }

    if (!usuario.senha) {
      errors.senha = "Senha é obrigatória.";
    }

    if (!usuario.senhaConfirmacao) {
      errors.senhaConfirmacao = "Confirmação de senha é obrigatória.";
    }

    if (usuario.senha !== usuario.senhaConfirmacao) {
      errors.senhaConfirmacao = "Senhas não conferem.";
    }

    if (!usuario.aceiteTermos) {
      errors.aceiteTermos =
        "É preciso aceitar os termos da LGPD para continuar.";
    }

    return errors;
  };

  return (
    <div className="registro-wrapper">
      <Container fluid bsPrefix="m-0">
        <Row className="content-registro">
          <Col md={8} lg={8} xs={12}>
            <Card className="flex-grow-1">
              <Row className="g-0">
                <Col md={4} className="column-img-registro">
                  <img
                    src={logo}
                    alt="Imagem de registro"
                    className="img-fluid card-img"
                  />
                </Col>
                <Col md={8}>
                  <Card.Body className="h-100 d-flex flex-column justify-content-evenly m-1">
                    <div className="mb-1 mt-3 ">
                      <h2 className="fw-bold text-uppercase mb-2">Quiz</h2>
                      <p className="mb-4">
                        Por favor, insira seus dados para se juntar a nós!
                      </p>
                      <Form
                        onSubmit={handleSubmit}
                        className="w-100 d-flex flex-column justify-content-evenly">
                        <div>
                          <Row className="content-nome">
                            <Form.Group
                              as={Col}
                              xs={12}
                              md={8}
                              className="mb-2"
                              controlId="formFullName">
                              <Form.Label className="text-center">
                                Nome de usuário
                              </Form.Label>
                              <Form.Control
                                size="sm"
                                name="nome"
                                type="text"
                                placeholder="Digite seu nome"
                                onChange={handleChange}
                                isInvalid={!!errors.nome}
                              />
                              <Form.Control.Feedback
                                type="invalid"
                                className="text-erro">
                                {errors.nome}
                              </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group
                              as={Col}
                              xs={12}
                              md={6}
                              className="mb-2"
                              controlId="formBirthDate">
                              <Form.Label>Data de nascimento</Form.Label>
                              <Form.Control
                                size="sm"
                                name="dataNascimento"
                                type="date"
                                placeholder="Digite sua data de nascimento"
                                onChange={handleChange}
                                isInvalid={!!errors.dataNascimento}
                              />
                              <Form.Control.Feedback
                                type="invalid"
                                className="text-erro">
                                {errors.dataNascimento}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Row>
                          <Row className="content-email">
                            <Form.Group
                              as={Col}
                              xs={12}
                              md={6}
                              className="mb-2"
                              controlId="formEmail">
                              <Form.Label className="text-center">
                                Email
                              </Form.Label>
                              <Form.Control
                                size="sm"
                                name="email"
                                type="email"
                                placeholder="Digite seu email"
                                list="email-options"
                                onChange={handleChange}
                                isInvalid={!!errors.email}
                              />
                              <Form.Control.Feedback
                                type="invalid"
                                className="text-erro">
                                {errors.email}
                              </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group
                              as={Col}
                              xs={12}
                              md={6}
                              className="mb-2"
                              controlId="formPhoneNumber">
                              <Form.Label>Telefone</Form.Label>
                              <Form.Control
                                size="sm"
                                name="phoneNumber"
                                type="tel"
                                placeholder="(00) 00000-0000"
                                value={usuario.phoneNumber}
                                onChange={handleChange}
                                isInvalid={!!errors.phoneNumber}
                              />
                              {errors.phoneNumber && (
                                <div className="invalid-feedback text-erro">
                                  {errors.phoneNumber}
                                </div>
                              )}
                            </Form.Group>
                          </Row>
                          <Row className="content-senha">
                            <Form.Group
                              as={Col}
                              xs={12}
                              md={6}
                              controlId="formBasicPassword">
                              <Form.Label>Senha</Form.Label>
                              <Form.Control
                                size="sm"
                                name="senha"
                                type="password"
                                placeholder="Senha"
                                onChange={handleChange}
                                isInvalid={!!errors.senha}
                              />
                              <Form.Control.Feedback
                                type="invalid"
                                className="text-erro">
                                {errors.senha}
                              </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group
                              as={Col}
                              xs={12}
                              md={6}
                              controlId="formConfirmPassword">
                              <Form.Label>Confirme sua senha</Form.Label>
                              <Form.Control
                                size="sm"
                                name="senhaConfirmacao"
                                type="password"
                                placeholder="Confirme sua senha"
                                onChange={handleChange}
                                isInvalid={!!errors.senhaConfirmacao}
                              />
                              <Form.Control.Feedback
                                type="invalid"
                                className="text-erro">
                                {errors.senhaConfirmacao}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Row>

                          <Form.Group
                            className="mb-2"
                            controlId="formLgpdConsent">
                            <div>
                              <Form.Check
                                name="aceiteTermos"
                                type="checkbox"
                                label={
                                  <>
                                    Eu aceito os termos da LGPD e a{" "}
                                    <a
                                      href="#"
                                      onClick={handleOpenModal}
                                      rel="noopener noreferrer">
                                      política de privacidade
                                    </a>
                                    .
                                  </>
                                }
                                checked={usuario.aceiteTermos || false}
                                onChange={handleChange}
                                isInvalid={!!errors.aceiteTermos}
                              />

                              <ModalPDF
                                show={showModal}
                                handleClose={handleCloseModal}
                                fileUrl={pdfUrl}
                              />
                            </div>
                            <Form.Control.Feedback type="invalid">
                              {errors.aceiteTermos}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </div>

                        <div className="d-grid">
                          <Button variant="primary" type="submit">
                            Sign Up
                          </Button>
                        </div>
                      </Form>
                    </div>
                    <div className="mt-3 text-center">
                      <p className="mb-0">
                        Já tem uma conta?{" "}
                        <Link to="/login" className="text-primary fw-bold">
                          Sign In
                        </Link>
                      </p>
                    </div>
                  </Card.Body>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ContentRegistroUsuario;
